export default __webpack_public_path__ + "static/media/Group1778.b37bab78.svg";